export default __webpack_public_path__ + "static/media/logo-clara.8ca0e18b.png";